export const NervosSettings = {
    TestNet: {
        RPC: "https://testnet.ckbapp.dev/rpc",
        Indexer: "https://testnet.ckbapp.dev/indexer",
        API: "https://testnet-api.explorer.nervos.org/api/v1/"
    },
    Mainnet: {
        RPC: "https://mainnet.ckb.dev/rpc",
        Indexer: "https://mainnet.ckb.dev/indexer_rpc",
        API: "https://mainnet-api.explorer.nervos.org/api/v1/"
    }
}